import { render, staticRenderFns } from "./UploadFileItem.vue?vue&type=template&id=35f2c2f2&scoped=true"
import script from "./UploadFileItem.vue?vue&type=script&lang=js"
export * from "./UploadFileItem.vue?vue&type=script&lang=js"
import style0 from "./UploadFileItem.vue?vue&type=style&index=0&id=35f2c2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f2c2f2",
  null
  
)

export default component.exports